export class Color {
    ids: any
    colorName: string;
    colorCode: string;
}